// extracted by mini-css-extract-plugin
export default {"form":"NotificationSearchRisk_form__baqYF","formLabel":"NotificationSearchRisk_formLabel__GuJCR"};